"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commonCta = require("@mmc/common-cta");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _reactRedux = require("react-redux");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactRouter = require("react-router");
var _card = _interopRequireDefault(require("../styles/card.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var removeSpaces = function removeSpaces(str) {
  return str.replace(' ', '_');
};

// Will need to update this/make a second function that doesn't take the 'link' but takes checkbox pos's
// Also may need to transplant helper functions from checkboxes in forms?
var handleChange = function handleChange(params) {
  return function (order, updateInternal) {
    var link = params.link,
      handleFieldChange = params.handleFieldChange,
      image = params.image,
      mainHeading = params.mainHeading;
    updateInternal(order);
    handleFieldChange([link], image, mainHeading);
  };
};
var updateParent = function updateParent(updateInternal, order) {
  return function () {
    updateInternal(order);
  };
};
var Card = function Card(_ref) {
  var theme = _ref.theme,
    mainHeading = _ref.mainHeading,
    paragraph = _ref.paragraph,
    link = _ref.link,
    image = _ref.image,
    altText = _ref.altText,
    selectButton = _ref.selectButton,
    handleFieldChange = _ref.handleFieldChange,
    order = _ref.order,
    selected = _ref.selected,
    updateInternal = _ref.updateInternal,
    selectStyle = _ref.selectStyle,
    downloadPDFText = _ref.downloadPDFText,
    linkClasses = _ref.linkClasses,
    market = _ref.market,
    downloadpdfList = _ref.downloadpdfList;
  var maxNumber = 999;
  var inputId = Math.floor(Math.random() * maxNumber); // generating a random 3 digit number to create unique ID's

  var handleChangeSelector = function handleChangeSelector() {
    return handleFieldChange ? handleChange({
      link: link,
      handleFieldChange: handleFieldChange,
      image: {
        image: image,
        altText: altText
      },
      mainHeading: mainHeading
    })(order, updateInternal) : updateParent(updateInternal, order);
  };
  var publishPdfDownloadToDataLayer = function publishPdfDownloadToDataLayer() {
    var splitLink = link.split('/');
    var fileName = splitLink[splitLink.length - 1];
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'file_download',
        comp_page: {
          file_name: fileName ? fileName.toLowerCase() : null,
          link: link ? "" + (!/^(http|https):/.test(link) ? window.location.origin : '') + link : null,
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: mainHeading ? mainHeading.toLowerCase() : null,
          file_type: link && link.toLowerCase().includes('price-lists') ? 'price list' : 'catalog',
          download_type: 'download'
        }
      });
    }
  };
  var renderCTA = function renderCTA() {
    return downloadpdfList && Array.isArray(downloadpdfList) && downloadpdfList.length > 0 ? downloadpdfList == null ? void 0 : downloadpdfList.map(function (item, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _card["default"].pdfLink
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        classes: linkClasses,
        data: {
          priority: 'lowIcon',
          openNewTab: true,
          icon: 'Download',
          url: item == null ? void 0 : item.url,
          label: item == null ? void 0 : item.downloadpdfLabel,
          ariaLabel: "Download " + mainHeading + " document"
          /* GraphQL does not currently pass in an icon; it assumes the link is to a PDF download. */
        },
        mouseDownEvent: function mouseDownEvent() {
          return publishPdfDownloadToDataLayer();
        }
      }));
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: _card["default"].pdfLink
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      classes: linkClasses,
      data: {
        priority: 'lowIcon',
        openNewTab: true,
        icon: 'Download',
        url: link,
        label: downloadPDFText,
        ariaLabel: "Download " + mainHeading + " document"
        /* GraphQL does not currently pass in an icon; it assumes the link is to a PDF download. */
      },
      mouseDownEvent: function mouseDownEvent() {
        return publishPdfDownloadToDataLayer();
      }
    }));
  };
  var renderRadio = function renderRadio() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      name: "download_brochure",
      id: "" + removeSpaces(mainHeading) + inputId,
      value: order,
      className: _card["default"].optionInput,
      onChange: handleChangeSelector,
      defaultChecked: order === selected
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "" + removeSpaces(mainHeading) + inputId,
      className: _card["default"].optionLabel + " " + theme.inputsAndOptions
    }, selectButton));
  };

  // Take styles from forms to fix the checkbox display
  var renderMulti = function renderMulti() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
      className: "" + _card["default"].optionInput,
      type: "checkbox",
      name: mainHeading + "-" + order,
      id: "" + removeSpaces(mainHeading) + inputId
      // checked={value.indexOf(option.key) >= 0 ? true : false} //reimplwement this somehow?
      ,
      required: true,
      value: order,
      onChange: handleChangeSelector
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: "" + removeSpaces(mainHeading) + inputId,
      className: _card["default"].optionLabel + " " + theme.inputsAndOptions
    }, mainHeading));
  };
  var renderDownload = function renderDownload() {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      classes: linkClasses,
      data: {
        priority: 'lowIcon',
        openNewTab: true,
        icon: 'Download',
        url: link,
        label: 'Download',
        ariaLabel: 'Download'
      }
    }));
  };

  // A table to lookup which input to render
  var renderOptions = function renderOptions(style) {
    if (style === 'single') {
      return renderRadio();
    }
    if (style === 'downloadPDF') {
      return renderCTA();
    }
    if (style === 'multi') {
      return renderMulti();
    }
    if (style === 'download') {
      return renderDownload();
    }
    return renderRadio();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme['col-md-3']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _card["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _card["default"].imageWrapper
  }, image ? /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _card["default"].image,
    src: image,
    alt: altText
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _card["default"].placeholderDiv + " " + _card["default"].image
  })), /*#__PURE__*/_react["default"].createElement("h2", {
    className: _card["default"].mainHeading + " " + theme.headingFour + " " + theme.marginBottom20
  }, mainHeading), /*#__PURE__*/_react["default"].createElement("p", {
    className: _card["default"].paragraph + " " + theme.bodyCopy + " " + theme.marginBottom20
  }, paragraph), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_card["default"].selectWrapper)
  }, renderOptions(selectStyle))));
};
Card.displayName = 'Card';
Card.defaultProps = {
  theme: {},
  handleFieldChange: function handleFieldChange() {
    return null;
  }
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(Card));
exports["default"] = _default;